import { Folder, FolderOutlined, Home, HomeOutlined } from "@mui/icons-material";

import analytics from "fond/analytics";
import { IconLink } from "fond/widgets/IconBar";

export const HomeIconBarContent: React.FC = () => {
  return (
    <>
      <IconLink data-testid="side-home-button" Icon={HomeOutlined} ActiveIcon={Home} to="/" onClick={() => analytics.track("iconbar.home.clicked")}>
        Home
      </IconLink>
      <IconLink
        data-testid="side-projects-button"
        Icon={FolderOutlined}
        ActiveIcon={Folder}
        to="/workspace"
        onClick={() => analytics.track("iconbar.projects.clicked")}
      >
        Projects
      </IconLink>
    </>
  );
};
